"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var PlaceholderTrigger = /** @class */ (function () {
    function PlaceholderTrigger(id, callback) {
        var _this = this;
        this.handler = function (e) {
            if (e.detail.id === _this.id && typeof _this.callback === "function") {
                _this.callback(e.detail.data);
            }
        };
        this.id = id;
        this.callback = callback;
    }
    PlaceholderTrigger.prototype.fire = function (data) {
        var event = new CustomEvent(constants_1.PLACEHOLDER_TRIGGER_EVENT, {
            detail: {
                id: this.id,
                data: data,
            },
        });
        document.dispatchEvent(event);
    };
    PlaceholderTrigger.prototype.listen = function () {
        document.addEventListener(constants_1.PLACEHOLDER_TRIGGER_EVENT, this.handler);
    };
    PlaceholderTrigger.prototype.unlisten = function () {
        document.removeEventListener(constants_1.PLACEHOLDER_TRIGGER_EVENT, this.handler);
    };
    return PlaceholderTrigger;
}());
exports.default = PlaceholderTrigger;
//# sourceMappingURL=PlaceholderTrigger.js.map